import React from 'react'
import { Box, useStyleConfig } from '@chakra-ui/react'
import PropTypes from 'prop-types'

function CardHeader(props) {
  const { variant, children, ...rest } = props
  const styles = useStyleConfig('CardHeader', { variant })

  return (
    <Box __css={styles} {...rest}>
      {children}
    </Box>
  )
}

CardHeader.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
}

export default CardHeader
